<template>
  <div>
    <label v-if="label" class="pl-2 label-text">
      {{ label }}
      <v-icon v-if="required" class="uikit-icon mini-star size-mini-star error" />
    </label>

    <label
      class="mt-1 mb-4 input-file d-flex justify-center align-center files_realm"
      :class="disabled ? '': 'input-file-cursor-pointer input-file-hover'"
      @drop="dropFile"
      @dragenter.prevent
      @dragover.prevent
    >
      <v-icon class="uikit-icon paperclip primary mr-2" />
      <input :disabled="disabled" type="file" name="file" @change="addFile">
      <span>Прикрепить файл</span>
    </label>

    <div
      v-for="(file, index) in files" :key="index"
      class="my-2 d-flex d-inline justify-space-between align-center"
    >
      <div :class="file.name.includes('.pdf') ? '' : ''" @click="selectFile(file)">
        <v-icon class="uikit-icon paperclip primary mr-2 size-20" />
        <span class="file-link-text">{{ file.name | shortName }}</span>
      </div>

      <div>
        <v-icon
          class="uikit-icon download download-btn mr-4 size-20"
          :disabled="disabled"
          @click="downloadFile(file)"
        />
        <v-icon
          class="uikit-icon trash remove-btn size-20"
          :disabled="disabled"
          @click="removeFile(file)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UIFilesInput',

  filters: {
    shortName(value) {
      if (!value) return ''

      const windowWidth = 1200
      const maxSymbols = 30
      const pointLength = (windowWidth / maxSymbols)
      const maxLenName = Math.round(window.innerWidth / pointLength)

      if (value.length > maxLenName) return `${value.slice(0, maxLenName)}...`
      return value
    },
  },

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Выберите файл',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({ files: [] }),

  methods: {
    changeData(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },

    dropFile(event) {
      event.preventDefault()
      if (event.dataTransfer?.files.length) this.$emit('addFile', event.dataTransfer?.files[0])
    },

    addFile(event) {
      // this.files.push(event.target.files[0])
      this.$emit('addFile', event.target.files[0])
    },

    selectFile(val) {
      if (val.name.includes('.pdf')) {
        this.$emit('selectFile', val)
      }
    },

    downloadFile(val) {
      this.$emit('downloadFile', val)
    },

    removeFile(val) {
      this.$emit('removeFile', val)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.files = val ? val.map((el) => {
          // eslint-disable-next-line no-param-reassign
          el.name = el.originalName
          return el
        }) : []
      },
    },
  },
}
</script>

<style scoped lang="scss">
.file-link-text {
  color: var(--v-primary-base);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
}

.input-file {
  height: 56px;
  position: relative;
  display: inline-block;
}

.input-file-cursor-pointer {
  cursor: pointer;
}

.input-file-cursor-pointer span {
  cursor: pointer;
}

.input-file-hover:hover {
  /*box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 4px 32px rgba(0, 0, 0, 0.06) !important;*/
  border: 2px solid var(--v-primary-base)
}

.input-file span {
  position: relative;
  display: inline-block;
  outline: none;
  text-decoration: none;
  vertical-align: middle;
  color: var(--v-primary-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  text-align: center;
  border-radius: 4px;
  background-color: transparent;
  height: 40px;
  padding: 10px 0;
  box-sizing: border-box;
  border: none;
  margin: 0;
  transition: background-color 0.2s;
}
.input-file input[type=file] {
  position: absolute;
  z-index: -1;
  opacity: 0;
  display: block;
  width: 0;
  height: 0;
}

.input-file input[type=file]:focus + span {
  box-shadow: transparent;
}

.input-file:hover span {
  background-color: transparent;
}
.input-file:active span {
  background-color: transparent;
}

.input-file input[type=file]:disabled + span {
  background-color: transparent;
}

.files_realm {
  border-radius: 8px;
  border: 2px dashed var(--v-primary-base)
}

.download-btn:hover {
  background: var(--v-primary-base) !important
}

.remove-btn:hover {
  background: var(--v-error-base) !important
}
</style>
